/* Comparison slider touch drag (moved from blocks/comparison-slider.liquid, Nov 2 2026, so blog posts can reuse it; see the note in that block). */
(function () {
  if (window.__mmCsTouch) return; window.__mmCsTouch = true;
  function setFrom(cs, e) {
    var w = cs.querySelector('[data-comparison-slider]'), sl = cs.querySelector('input.cs-slider'); if (!w || !sl) return;
    var r = w.getBoundingClientRect(), v = w.dataset.orientation === 'vertical' ? 100 - (e.clientY - r.top) / r.height * 100 : (e.clientX - r.left) / r.width * 100;
    v = Math.max(0, Math.min(100, Math.round(v)));
    if (cs.setValue) cs.setValue(v); else { sl.value = v; w.style.setProperty('--compare', String(v)); }
  }
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    var cs = e.target.closest && e.target.closest('comparison-slider-component'); if (!cs) return;
    drag = { cs: cs, x: e.clientX, y: e.clientY, on: false, id: e.pointerId };
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    if (!drag.on) {
      var dx = Math.abs(e.clientX - drag.x), dy = Math.abs(e.clientY - drag.y), vert = drag.cs.querySelector('[data-orientation="vertical"]');
      if (dx < 6 && dy < 6) return;
      if (vert ? dx > dy : dy > dx) { drag = null; return; }      // the page scroll direction: let it scroll
      drag.on = true;
    }
    setFrom(drag.cs, e);
  }, true);
  document.addEventListener('pointerup', function (e) { if (drag && !drag.on && e.pointerId === drag.id) setFrom(drag.cs, e); drag = null; }, true);
  document.addEventListener('pointercancel', function () { drag = null; }, true);
})();
